module.exports = __webpack_public_path__ + "static/pwc-hackathon-929c0825dd91df9740d0b81735581403.jpg";